<header-title [model]="headerTitle"></header-title>
<section role="main" class="content-body tab-menu-opened">
    <div class="row">
        <div class="col">
            <section class="card">
                <header class="card-header">
                    <h2 class="card-title">Create New Audit Type</h2>
                </header>
                <div class="card-body py-5">
                    <form (submit)="addAuditType()" [formGroup]="addAddAuditTypeFormGroup">
                        <fieldset>
                            <div class="panel-body">
                                <error-message [errors]="errors"></error-message>
                                <div class="row mt-3">
                                    <div class="col-md-3">
                                        <label class="control-label">Name</label>
                                        <input type="text" class="form-control" formControlName="name" />
                                    </div>
                                </div>
                            </div>
                            <footer class="panel-footer mt-3">
                                <div class="row">
                                    <div class="col-sm-9 col-sm-offset-3">
                                        <button class="btn btn-success" type="submit">Create</button>
                                        <button class="btn btn-info ml-1" type="button" (click)="onBack()">Back</button>
                                    </div>
                                </div>
                            </footer>
                        </fieldset>
                    </form>
                </div>
            </section>
        </div>
    </div>
</section>
